export const TABLET_WIDTH = 768;
export const MOBILE_WIDTH = 485;
